/**
 * Web Intents X — le seul chemin de publication de l'app. (Brief §1)
 *
 * L'app n'appelle JAMAIS l'API de publication. Elle construit une URL qui
 * ouvre le composer officiel de X, pré-rempli. Le clic final est humain, dans
 * l'interface de X. C'est le principe non négociable du brief, et c'est aussi
 * pour ça qu'aucun scope d'écriture n'est demandé.
 */
const INTENT_BASE = "https://x.com/intent/post";
/**
 * URL du composer X pré-rempli en réponse à un tweet.
 *
 * `encodeURIComponent` via `URLSearchParams` : un brouillon contenant `&`, `#`
 * ou un saut de ligne doit arriver intact dans le composer.
 */
export function buildReplyIntentUrl(tweetId, draft) {
    const params = new URLSearchParams({
        in_reply_to: tweetId,
        text: draft,
    });
    return `${INTENT_BASE}?${params.toString()}`;
}
/** URL du tweet original, pour aller le lire dans son contexte. */
export function buildTweetUrl(handle, tweetId) {
    return `https://x.com/${handle.replace(/^@/, "")}/status/${tweetId}`;
}
/** URL d'un profil. */
export function buildProfileUrl(handle) {
    return `https://x.com/${handle.replace(/^@/, "")}`;
}
//# sourceMappingURL=intent.js.map